import * as types from "./mutation_types";

export default {
  [types.SET_ERROR](state, error) {
    Object.assign(state, { error });
  },

  [types.SET_LOAN_OFFICERS](state, data) {
    Object.assign(state, {
      error: "",
      loan_officers: data,
    });
  },

  [types.SET_LOAN_OFFICER_SELECTED](state, data) {
    Object.assign(state, {
      error: "",
      loan_officer_selected: data,
    });
  },

  [types.TOGGLE_LOADING](state) {
    Object.assign(state, { isLoading: !state.isLoading });
  },
};
